<template>
    <div class="muven-container">
        <div class="muven-router-name-container">
            <p class="muven-router-name">Faturamento</p>
        </div>

        <div class="muven-content">
            <div class="modal" tabindex="-1" role="dialog" id="muven-subscriber-billing-contact-information-modal">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">
                                <span>Dados de cobrança</span>
                            </h5>
                        </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12 col-md-6 form-group">
                                    <label>Telefone fixo</label>
                                    <input type="text" 
                                        class="form-control"
                                        :disabled="!userAuthenticated.isAdmin()"
                                        v-model="billingContactInformation.phone">
                                </div>

                                <div class="col-12 col-md-6 form-group">
                                    <label>Celular</label>
                                    <input type="text" 
                                        class="form-control"
                                        :disabled="!userAuthenticated.isAdmin()"
                                        v-model="billingContactInformation.cellPhone">
                                </div>

                                <div class="col-12 form-group">
                                    <label>Emails</label>
                                    <textarea type="text" 
                                        class="form-control"
                                        :disabled="!userAuthenticated.isAdmin()"
                                        :class="{'is-invalid': !billingContactInformation.hasEmails()}"
                                        v-model="billingContactInformation.emailsStringified"></textarea>
                                        <small class="text-muted" v-show="billingContactInformation.hasEmails()">Para adicionar mais de um email, basta separar as informações com vírgula</small>
                                        <small class="text-danger" v-show="!billingContactInformation.hasEmails()">Deve ser informado pelo menos um email</small>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" 
                                v-if="userAuthenticated.isAdmin()"
                                class="btn btn-primary" 
                                @click="updateBillingContactInformation(billingContactInformation)"
                                :disabled="!billingContactInformation.isValid() || updatingBillingContactInformation">
                                Gravar
                                <Loading v-show="updatingBillingContactInformation" />
                            </button>

                            <button type="button" 
                                class="btn btn-outline-secondary" 
                                @click="closeSubscriberContactInformationModal()">Fechar</button>
                        </div>
                    </div>
                </div>
            </div>

            <Loading page v-show="loading" />

            <Breadcrumb :items="breadcrumbList" class="mb-3" v-if="!loading"/>

            <div v-show="!loading" class="mb-3">
                <button type="button"
                    class="btn btn-outline-secondary"
                    @click="showSubscriberContactInformationModal()">
                    Dados de cobrança
                </button>
            </div>

            <NothingFound v-if="nothingToShow" />

            <div class="table-responsive" v-show="!loading && !nothingToShow">
                <table class="table table-sm table-striped">
                    <thead>
                        <tr>
                            <th>Vencimento</th>
                            <th>Valor</th>
                            <th>Status</th>
                            <th>Boleto</th>
                            <th>NFS-e</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(subscriberBilling, indexSubscriberBilling) in billingList" :key="indexSubscriberBilling">
                            <td>{{subscriberBilling.dueDate | dateFilterFromString}}</td>                            
                            <td>{{subscriberBilling.amount | currency}}</td>
                            <td>
                                <span v-if="!subscriberBilling.hasBeenPaid() && !subscriberBilling.isOverdue() && !subscriberBilling.hasBeenCanceled()">
                                    <span class="muven-td-icon">
                                        <fa icon="hourglass-start" 
                                            class="text-muted" />
                                    </span>

                                    <span>Em aberto</span>
                                </span>

                                <span v-if="subscriberBilling.hasBeenPaid()">
                                    <span class="muven-td-icon">
                                        <fa icon="check-circle" 
                                            class="text-success" />
                                    </span>

                                    <span>Pago</span>
                                </span>

                                <span v-if="subscriberBilling.isOverdue() && !subscriberBilling.hasBeenCanceled()">
                                    <span class="muven-td-icon">
                                        <fa icon="window-close" 
                                            class="text-danger" />
                                    </span>

                                    <span>Vencido</span>
                                </span>

                                <span v-if="subscriberBilling.hasBeenCanceled()">
                                    <span class="muven-td-icon">
                                        <fa icon="window-close" 
                                            class="text-danger" />
                                    </span>

                                    <span>Cancelado</span>
                                </span>
                            </td>
                            <td>
                                <a v-show="subscriberBilling.hasBillet() && !subscriberBilling.hasBeenCanceled()"
                                    :href="subscriberBilling.billetUrl"
                                    target="_blank">
                                    <span class="badge badge-info">Visualizar</span>
                                </a>

                                <a v-show="subscriberBilling.hasInvoice() && subscriberBilling.hasBeenCanceled()"
                                    :href="subscriberBilling.billetUrl"
                                    target="_blank">
                                    <span class="badge badge-danger">Cancelado</span>
                                </a>

                                <span v-show="!subscriberBilling.hasBillet()">
                                    <span class="badge badge-dark">Não</span>
                                </span>
                            </td>
                            <td>
                                <a v-show="subscriberBilling.hasInvoice() && !subscriberBilling.hasBeenCanceled()"
                                    :href="subscriberBilling.invoiceUrl"
                                    target="_blank">
                                    <span class="badge badge-info">Visualizar</span>
                                </a>

                                <a v-show="subscriberBilling.hasInvoice() && subscriberBilling.hasBeenCanceled()"
                                    :href="subscriberBilling.invoiceUrl"
                                    target="_blank">
                                    <span class="badge badge-danger">Cancelado</span>
                                </a>

                                <span v-show="!subscriberBilling.hasInvoice()">
                                    <span class="badge badge-dark">Não</span>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>                    

                <ListCount :amount="billingList.length" />
            </div>
        </div>
    </div>    
</template>

<script>
import {infoOrPlaceholder} from '@/utils/filters/InformationOrPlaceholderFilter'
import subscriberService from '../services/SubscriberService'
import ModalService from '../../utils/services/ModalService'
import { SubscriberBillingContactInformationModel } from '../models/SubscriberBillingContactInformationModel'
import { mapState } from 'vuex'

const ID_SUBSCRIBER_BILLING_CONTACT_INFORMATION_MODAL = '#muven-subscriber-billing-contact-information-modal'

export default {
    name: 'StoreListView',
    data() {
        return {
            loading: true,
            updatingBillingContactInformation: false,
            billingList: [],
            billingContactInformation: new SubscriberBillingContactInformationModel(),
            breadcrumbList: [
                {
                    id: 1,
                    description: 'Atendimento',
                    path: '/atendimento'
                },
                {
                    id: 1,
                    description: 'Faturamento',
                    path: '/atendimento/faturamento'
                },
            ]
        }
    },
    filters: {
        infoOrPlaceholder,
        dateFilterFromString(input) {
            const year = input.split('-')[0]
            const month = input.split('-')[1]
            const day = input.split('-')[2]

            return `${day}/${month}/${year}`
        },
    },
    async mounted() {
        this.loading = true

        try {
            [
                this.billingList, 
                this.billingContactInformation,
            ] = await Promise.all([
                subscriberService.getSubscribersBillings(),
                subscriberService.getBillingContactInformation(),
            ]);
        } catch (err) {
            this.$floatingAlert.error({
                message: err.message,
            })
        }

        this.loading = false
    },
    methods: {
        async updateBillingContactInformation(contactInfo) {
            try {
                await subscriberService.updateBillingContactInformation(contactInfo.normalize())
                this.$floatingAlert.success({
                    message: 'Dados de cobrança atualizados com sucesso.',
                })
            } catch (err) {
                this.$floatingAlert.error({
                    message: err.message,
                })
            }
        },
        showSubscriberContactInformationModal() {
            ModalService.show(ID_SUBSCRIBER_BILLING_CONTACT_INFORMATION_MODAL)
        },
        closeSubscriberContactInformationModal() {
            ModalService.hide(ID_SUBSCRIBER_BILLING_CONTACT_INFORMATION_MODAL)
        },
    },
    computed: {
        ...mapState({
            userAuthenticated: state => state.userAuthenticated,
        }),
        nothingToShow() {
            return !this.loading && !this.billingList.length
        },             
    },
}
</script>
